import React from "react";
import Layout from "./pages/Layout";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import ProjectsPage from "./pages/Projects";
import GiraffeProject from "./pages/GiraffensHjarta";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./components/Content.css";
import COLORS from "./components/Colors";
import LuminaProject from "./pages/LuminaProject";

document.body.style.backgroundColor = COLORS.background;
function App() {
  return (
    //contains all the paths
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}></Route>
          <Route index element={<Home />} />
          <Route path="/about" exact element={<About />}>
            {" "}
          </Route>
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route
            path="/projects/giraffenshjarta"
            element={<GiraffeProject />}
          />
          <Route path="/projects/lumina" element={<LuminaProject />} />
        </Routes>
      </Router>
    </>
  );
}
export default App;
